import React, { PureComponent } from 'react'
import { Button, Collapse } from 'reactstrap'

export default class CollapseItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      active: false
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({ active: !this.state.active })
  }

  render() {
    return (
      <div style={{ padding: 15, textAlign: 'center' }}>
        <Button type="primary" onClick={this.toggle}>
          {this.props.buttonText}
        </Button>
        <Collapse isOpen={this.state.active}>{this.props.children}</Collapse>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/CollapseItem.js